export default "<section class=\"report-card\">\n   <dc-reportcard reportcard=\"vm.reportcard\"></dc-reportcard>\n</section>";